import React, { useEffect, useState, useMemo } from "react"
import { SECURITY_TYPE } from "config/const"
import { get, isEmpty, find } from "lodash"
import { FutureTemplate } from "components/templates/domestic/future"
import { FutureOnlyTemplate } from "components/templates/domestic/future"
import { OpOnlyTemplate } from "components/templates/domestic/future"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import { label } from "components/organisms/panel/future"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const useSymbolDetail = (): any => {
  const [symbolDetail, setSymbolDetail] = useState<APIResponse.Res>({})

  const callSymbolDetail = async (symbol: any) => {
    if (!isEmpty(symbol)) {
      const res: APIResponse.Res | {} = await APIs.SymbolDetail.SymbolDetail({
        SecurityType: get(symbol, "SecurityType"),
        Symbol: get(symbol, "Symbol"),
        Exchange: 2,
      })
      setSymbolDetail(res)
    } else {
      // setSymbolDetail({})
      return
    }
  }

  return [callSymbolDetail, symbolDetail]
}

const FUTURE_PARAM = {
  NewestOnly: ["101,121,107,155,171", "901,907"],
  Main: ["101", "901"],
  Tse: ["121"],
  Emerging: ["107", "907"],
  All: ["171"],
  Change: ["155"],
}

const useFuture = (): any => {
  const [currentContent, changeContent] = useState(0)
  const [apiData, setApiData] = useState<APIResponse.Res>({})
  const [displayId, changeDisplay] = useState<string>(label[0].id)
  const [refresh, setRefresh] = useState(false)
  const [underlyingAssetData, setUnderlyingAssetData] = useState<
    APIResponse.Res
  >({})
  const loadResistId = useMemo(() => uuid(), [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const request = async (displayId: any) => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    if (!currentContent) {
      const newestCountMajor =
        displayId === "NewestOnly" ? { NewestCount: 2 } : {}
      const newestCountMini =
        displayId === "NewestOnly" ? { NewestCount: 5 } : {}
      const target = get(FUTURE_PARAM, displayId)

      if (target.length === 2) {
        const response: any = await Promise.all([
          APIs.SymbolDetail.SymbolList({
            Exchange: "2",
            TargetSecurityTypes: target[1],
            MajorMonthOnly: true,
            ...newestCountMajor,
          }),
          APIs.SymbolDetail.SymbolList({
            Exchange: "2",
            TargetSecurityTypes: target[0],
            MajorMonthOnly: true,
            ...newestCountMajor,
          }),
        ])
        const futureSymbolList: APIResponse.Res | {} = {
          ResultList: [...response[0].ResultList, ...response[1].ResultList],
          TotalCount: response[0].TotalCount + response[1].TotalCount,
        }
        setApiData(futureSymbolList)
      } else {
        const response: any = await APIs.SymbolDetail.SymbolList({
          Exchange: "2",
          TargetSecurityTypes: target[0],
          MajorMonthOnly: true,
          ...newestCountMini,
        })

        const futureSymbolList: APIResponse.Res | {} = {
          ResultList: response.ResultList,
          TotalCount: response.TotalCount,
        }
        setApiData(futureSymbolList)
      }
      //原資産データ取得
      const currentIndex = find(label, { id: displayId })
      const params = get(currentIndex, "requestDetail")
      const responseUnderlyingAsset = await APIs.SymbolDetail.SymbolDetail(
        params
      )
      setUnderlyingAssetData(get(responseUnderlyingAsset, "Symbol"))
    } else if (currentContent) {
      const responseUnderlyingAsset = await APIs.SymbolDetail.SymbolDetail({
        Symbol: "101",
        Exchange: 1,
        SecurityType: 0,
      })
      setUnderlyingAssetData(get(responseUnderlyingAsset, "Symbol"))
    }
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffect(() => {
    request(displayId)
  }, [currentContent, displayId])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) request(displayId)
  }, [isPageLoading])

  useEffect(() => {
    if (refresh) {
      request(displayId)
      setRefresh(false)
    }
  }, [refresh])

  return {
    apiData,
    currentContent,
    changeContent,
    changeDisplay,
    refresh,
    setRefresh,
    underlyingAssetData,
  }
}

export const Future = () => {
  const {
    apiData,
    currentContent,
    changeContent,
    changeDisplay,
    refresh,
    setRefresh,
    underlyingAssetData,
  } = useFuture()
  const [callSymbolDetailOP, symbolDetailOP] = useSymbolDetail()
  const [callSymbolDetailFuture, symbolDetailFuture] = useSymbolDetail()

  return (
    <FutureTemplate
      data={apiData}
      currentContent={currentContent}
      changeContent={changeContent}
      changeDisplay={changeDisplay}
      refresh={refresh}
      setRefresh={setRefresh}
      callSymbolDetail={
        currentContent === 1 ? callSymbolDetailOP : callSymbolDetailFuture
      }
      symbolDetail={currentContent === 1 ? symbolDetailOP : symbolDetailFuture}
      underlyingAssetData={underlyingAssetData}
    />
  )
}

export const FutureOnly = () => {
  const { apiData, changeDisplay } = useFuture()
  const [callSymbolDetail, symbolDetail] = useSymbolDetail()

  return (
    <FutureOnlyTemplate
      changeDisplay={changeDisplay}
      data={apiData}
      callSymbolDetail={callSymbolDetail}
      symbolDetail={symbolDetail}
    />
  )
}

export const OpOnly = () => {
  const { changeDisplay } = useFuture()
  const [callSymbolDetail, symbolDetail] = useSymbolDetail()
  return (
    <OpOnlyTemplate
      changeDisplay={changeDisplay}
      callSymbolDetail={callSymbolDetail}
      symbolDetail={symbolDetail}
    />
  )
}
